export function LinearChart({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.49996 18.3333H12.5C16.6666 18.3333 18.3333 16.6667 18.3333 12.5V7.5C18.3333 3.33334 16.6666 1.66667 12.5 1.66667H7.49996C3.33329 1.66667 1.66663 3.33334 1.66663 7.5V12.5C1.66663 16.6667 3.33329 18.3333 7.49996 18.3333Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.9166 15.4167C13.8333 15.4167 14.5833 14.6667 14.5833 13.75V6.25C14.5833 5.33334 13.8333 4.58334 12.9166 4.58334C12 4.58334 11.25 5.33334 11.25 6.25V13.75C11.25 14.6667 11.9916 15.4167 12.9166 15.4167Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.08329 15.4167C7.99996 15.4167 8.74996 14.6667 8.74996 13.75V10.8333C8.74996 9.91667 7.99996 9.16667 7.08329 9.16667C6.16663 9.16667 5.41663 9.91667 5.41663 10.8333V13.75C5.41663 14.6667 6.15829 15.4167 7.08329 15.4167Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
}
